/**
 * Created by laugh on 9/21/2017.
 */


export default function (state = "", action) {

    switch (action.type) {
        case 'SET_OFFER':
            return action.selectedOffer;
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/selected-offer.js